<!--
 * @Description:
 * @Date: 2019-12-31 14:53:59
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-03-27 18:45:28
-->
<template>
  <div>
    <el-menu
      :default-active="activeKey"
      class="home-menu"
      mode="horizontal"
      @select="handleSelect"
    >
      <template v-for="(item, index) in menus">
        <el-menu-item
          :key="index"
          :index="item.name"
          @select="handleSelect"
          v-if="!item.child"
        >
          {{ item.label }}
        </el-menu-item>
        <el-submenu
          :key="index"
          v-else
          :index="item.name"
          @select="handleSelect"
        >
          <template slot="title">{{ item.label }}</template>
          <el-menu-item
            v-for="(item2, index2) in item.child"
            :key="index2 + 10"
            :index="item2.name"
          >
            {{ item2.label }}
          </el-menu-item>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>

<script>
// import { getStorage } from '@/tools/storage';
// import { mapState } from '@/store/index.js';

export default {
  inject: ['forceReload'],
  data() {
    return {
      activeKey: 'home'
    };
  },
  computed: {
    menus() {
      return this.$store.state.user.menus;
    }
  },
  methods: {
    handleSelect(key) {
      if (key === this.$route.name) {
        // FIXME
        // v3首页使用这种方式刷新的话，会导致白屏
        key != 'home' && this.forceReload();
        return;
      }
      this.$router.push({
        name: key
      });
    }
  },
  created() {
    this.activeKey =
      this.$route.meta.parentName || this.$route.name.split('|')[0];
  },
  watch: {
    $route: {
      handler(v) {
        this.activeKey = v.name;
      }
    }
  }
  // mounted() {
  // this.menus = this.$store.state.roles || getStorage('roles');
  // }
};
</script>
<style lang="scss">
.home-menu {
  width: 100%;
  min-width: 1280px;
  .el-menu-item,
  .el-submenu .el-submenu__title {
    height: 40px;
    line-height: 40px;
  }
}
</style>
